'use client'
import { useEffect, useState } from 'react'
import { Dialog } from '@headlessui/react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import 'swiper/css/pagination'
import 'swiper/css'
import { sendRequest } from '@/lib/api-service'
import { FaRegCommentAlt } from 'react-icons/fa'

interface Testimonial{
	name:string;
	text:string
}


export default function TestimonialSection() {
	const placeholderTestimonials = [
		{ name: 'Ээж Энхзаяа', text: 'Маш гоё хөтөлбөртэй зуслан байна! Хүүхдүүд маань өдөр бүр шинэ зүйл сурч, байгальд цагийг өнгөрөөж байгаад би үнэхээр баяртай байна.' },
		{ name: 'Аав Дорж', text: 'Хүүхдүүд маань сэтгэл хангалуун, дахин ирнэ гэдэгт итгэлтэй байна. Ажилтнууд нь ч маш найрсаг, халамжтай байлаа. Маш их баярлалаа!' },
		{ name: 'Нандин-Эрдэнэ', text: 'Найзуудтайгаа олон гоё дурсамж бүтээсэн. Бүлгийнхэнтэйгээ ахиад уулзмаар байна, хөгжилтэй тоглоомууд, аяллууд үнэхээр сайхан байсан.' },
		{ name: 'Ээж Мөнгөнцэцэг', text: 'Анх удаа хүүхдээ зусланд явуулж байгаа болохоор санаа зовж байсан ч, хүүхэд маань инээд хөөртэй, олон найзтай болчихсон ирсэнд их баярлалаа. Дараа жил ч бас бүртгүүлнэ!' },
		{ name: 'Аав Энхбаяр', text: 'Хүүхдүүдийнхээ зураг, бичлэгийг хуваалцаж байгаад их таалагдсан. Харилцаа сайн, орчны аюулгүй байдал ч маш сайн хангасан байсан. Итгэлтэйгээр дахин илгээнэ.' },
		{ name: 'Тэмүүлэн', text: 'Би энэ зусланг хэзээ ч мартана гэж бодохгүй байна. Ууланд аялж, морь унаж, шинэ зүйл сурсан. Багш нар нь хөгжилтэй, сайн ойлгуулдаг хүмүүс байсан.' },
		{ name: 'Ээж Уянга', text: 'Энэ зуслан хүүхдийн өсөлт, хөгжилд үнэхээр сайнаар нөлөөлдөг юм байна. Өдөр бүрийн хөтөлбөр нь маш төлөвлөгдсөн, хүүхдүүдийг уйдаахгүй байхаар зохион байгуулжээ.' },
	] as Testimonial[]
	
	const [testimonials, setTestimonials] = useState<Testimonial[]>(placeholderTestimonials)
	const [isOpen, setIsOpen] = useState(false)
	const [name, setName] = useState('')
	const [text, setText] = useState('')

	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await sendRequest("GET", "/testimonials/");
				if(data!=null && data.length>2){
					setTestimonials(data);
				}
			} catch (error) {
				console.log(error)
			}
		};
		fetchData();
	}, []);

	const handleSubmit = async () => {
		setIsOpen(false)
		await sendRequest("POST", "/testimonials/send/", {name, text});
		setName('')
		setText('')
	}

	return (
		<div className='relative bg-white pb-6 overflow-hidden'>
			<FaRegCommentAlt className="absolute top-[20px] right-[-40px] w-40 h-40 sm:w-64 sm:h-64 text-mountain-900 opacity-10 pointer-events-none z-0" />

			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-4 relative z-10'>
				<h1 className="text-4xl lg:text-5xl font-bold text-sun-500 mb-10 drop-shadow-sm header uppercase text-center">
					Амрагч хүүхэд эцэг эхийн сэтгэгдэл
				</h1>

				<div className="relative">
					<Swiper
						modules={[Pagination]}
						spaceBetween={20}
						slidesPerView={1}
						pagination={{ clickable: true, el: '.custom-swiper-pagination' }}
						breakpoints={{
							640: { slidesPerView: 1 },
							768: { slidesPerView: 2 },
							1024: { slidesPerView: 3 },
						}}
					>
						{testimonials && 
						testimonials.map((item, i) => (
							<SwiperSlide key={i}>
								<div className="bg-white border-gray-200 border rounded-2xl shadow-sm p-5 m-4 h-full flex flex-col justify-between select-none">
									<div className="text-gray-800 mb-4 italic h-[270px] overflow-y-auto text-lg">&quot;{item.text}&quot;</div>
									<p className="text-gray-600 text-right font-semibold">– {item.name}</p>
								</div>
							</SwiperSlide>
						))}
					</Swiper>
					<div className="custom-swiper-pagination mt-10 flex justify-center" />
				</div>

				<div className="flex justify-center mt-10">
					<button
						onClick={() => setIsOpen(true)}
						className="text-white bg-mountain-900 font-semibold px-6 py-2 rounded-xl shadow hover:bg-gray-100 transition"
					>
						Сэтгэгдэл үлдээх
					</button>
				</div>
			</div>

			<Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
				<div className="fixed inset-0 bg-black/30" aria-hidden="true" />
				<div className="fixed inset-0 flex items-center justify-center p-4">
					<div className="bg-white max-w-md w-full rounded-2xl p-6 shadow-xl">
						<h2 className="text-lg font-bold mb-4">Сэтгэгдэл үлдээх</h2>
						<input
							type="text"
							placeholder="Нэр"
							value={name}
							onChange={e => setName(e.target.value)}
							className="w-full mb-3 p-2 border border-gray-300 rounded-md"
						/>
						<textarea
							placeholder="Сэтгэгдэл"
							value={text}
							onChange={e => setText(e.target.value)}
							className="w-full mb-3 p-2 border border-gray-300 rounded-md"
						/>
						<div className="flex justify-end gap-2">
							<button
								onClick={() => setIsOpen(false)}
								className="px-4 py-2 bg-gray-200 rounded-md"
							>
								Болих
							</button>
							<button
								onClick={handleSubmit}
								className="px-4 py-2 bg-mountain-900 text-white rounded-md"
							>
								Илгээх
							</button>
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	)
}
